import { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import PlayStoreBadge from "../Badge/PlayStore";
import PlayStoreQR from "../SVG/PlayStoreQR";
import AppStoreBadge from "../Badge/AppStore";

const DownloadApp = () => {
  // TODO: to use tailwind classnames and responsive breakpoints instead?
  const [mobileView, updateMobileView] = useState<boolean>();

  useEffect(() => {
    updateMobileView(isMobile);
  }, []);
  return (
    <>
      {!mobileView && (
        <div className='card flex flex-col items-center w-full'>
          <h2>Download Our App Now</h2>
          <div className='flex flex-wrap justify-around items-center w-full p-6'>
            <div className='flex flex-col text-center'>
              <PlayStoreQR />
              <p className='font-semibold mt-2'>Scan Me</p>
            </div>
            <PlayStoreBadge linkUrl='https://doubtnut.app.link/4VoS10hjKBb' />
            <AppStoreBadge linkUrl='https://tiny.doubtnut.com/iOS-app-10' />
            {/* TODO app store icon */}
          </div>
        </div>
      )}
      {mobileView && (
        <div className="flex flex-col items-center">
          <PlayStoreBadge linkUrl="https://play.google.com/store/apps/details?id=com.doubtnutapp&hl=en_US&utm_source=download_app_mweb&utm_medium=web_link&utm_campaign=web_viral&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1" />
          <AppStoreBadge linkUrl='https://tiny.doubtnut.com/iOS-app-10' />
        </div>
      )}
    </>
  );
};

export default DownloadApp;
